import { NgModule, Component, ViewChild, ViewChildren, OnInit, AfterViewInit, SecurityContext, ElementRef, Input } from '@angular/core';
import { Router, Route } from "@angular/router";
import { RouteURLConstants } from '../../../constants/upplm.constants';
import { DashboardResponse } from '../../../api/models/dashboardResponse';
import { UpsCommonService } from '../../../services/upplm.common.service';

@Component({
    selector: 'expired1',
    template: require('./dashboardExpired1.component.html')
})

export class Expired1Component {

    public ham: boolean = false;
    public paramsUrl: string = '?loc=en_US&placardid=';    

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;

    constructor(private router: Router,
        private _commonService: UpsCommonService) { }

    ngOnInit() {
        /* empty */
    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    searchInformation() {
        /* empty */
    }

    goToPlacardVerification() {
        this.router.navigateByUrl(`${RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE}?loc=${this._commonService.locale}&placardid=${this.dataSearch.placardId}`);
    }
}